import type { WhatsNewCarouselCard } from './types';

const CARD_TITLE_PREVIEW_LENGTH = 15;

function createAlphabeticDraftSuffix(index: number): string {
  const alphabetLength = 26;
  let value = index;
  let label = '';

  do {
    label = String.fromCharCode(65 + (value % alphabetLength)) + label;
    value = Math.floor(value / alphabetLength) - 1;
  } while (value >= 0);

  return label;
}

export function createCardDraftLabel(index: number): string {
  return `Card ${createAlphabeticDraftSuffix(index)}`;
}

function truncateCardPreview(value: string): string {
  return value.length > CARD_TITLE_PREVIEW_LENGTH ? `${value.slice(0, CARD_TITLE_PREVIEW_LENGTH)}...` : value;
}

export function formatCardTitle(card: WhatsNewCarouselCard): string {
  const label = card.draftLabel;
  const previewSource = card.title.trim();
  if (!previewSource) {
    return label;
  }

  return `${label} (${truncateCardPreview(previewSource)})`;
}

export function getNextCardDraftLabel(cards: Array<WhatsNewCarouselCard>): string {
  const usedLabels = new Set(cards.map((card) => card.draftLabel));
  let index = 0;
  let nextLabel = createCardDraftLabel(index);

  while (usedLabels.has(nextLabel)) {
    index += 1;
    nextLabel = createCardDraftLabel(index);
  }

  return nextLabel;
}

function moveItem<T>(items: Array<T>, index: number, offset: -1 | 1): Array<T> {
  const targetIndex = index + offset;
  if (targetIndex < 0 || targetIndex >= items.length) {
    return items;
  }

  const nextItems = [...items];
  [nextItems[index], nextItems[targetIndex]] = [nextItems[targetIndex], nextItems[index]];
  return nextItems;
}

export function moveCard(
  cards: Array<WhatsNewCarouselCard>,
  index: number,
  offset: -1 | 1,
): Array<WhatsNewCarouselCard> {
  return moveItem(cards, index, offset);
}
